import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';

/**
 * The content toggle component simply hides/shows some content without
 * any animations
 */
@Component({
    name: 'content-toggle',
})
export default class ContentToggle extends Mixins(MagicConfigMixin) {
    /**
     * Used to control the open state of the content toggle from
     * outside of this component.
     */
    @Prop({ type: Boolean, default: false })
    initiallyShown!: boolean;

    isVisible: boolean = false;

    toggle() {
        this.isVisible = !this.isVisible;
        this.emitChange();
    }

    @Watch('initiallyShown')
    onShownChange() {
        this.isVisible = this.initiallyShown;
    }

    /**
     * Emitted whenever the state of the toggle is changed by
     * this component.
     */
    @Emit('change')
    emitChange() {
        return this.isVisible;
    }
}
